export default "__VITE_ASSET__B_DT2065__"